import { Custompage } from "./Custompage";

export const Custompages = (): JSX.Element => {
  return <Custompage />;
};
